/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tq.js                                                                                */
/**********************************************************************************************************************/
/* Controller.TQ */

HafasWebapp.prototype.Controller.TQ = {
  currentTrainroute: null,
  currentResult: null,
  focusSelector: null, // for restoring focus after some action is performed
  index: function () {
    // leer
  },
  showResult: function (data) {
    if (data.ev) {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }
    Hafas.bind(this.Controller.TQ.showTrainroute, this)({data: data, additionalContext: 'TQ'});
  },
  hideResult: function () {
    var me = this;
    //Hafas('#TQ_Result').style.display = 'none';
    if (typeof me.Controller.TQ.currentTrainroute != 'undefined' && me.Controller.TQ.currentTrainroute != null) {
      me.Controller.TQ.currentTrainroute.hide();
      me.Controller.TQ.currentTrainroute = null;
      me.Controller.TQ.currentResult = null;
    }
  },
  selectStation: function (data) {
    if (this.Controller.TQ.currentResult != null && this.Controller.TQ.currentResult.stopL != null) {
      // fallback first before we compare and set the finally correct loc
      if (this.Controller.TQ.currentResult.stopL[data.locIndex] != undefined) {
      var loc = this.Controller.TQ.currentResult.stopL[data.locIndex].locResolved;
      }
      // array index and locIdx might not be the same, so we need to go through all stops and compare the idx value
      for (var i=0; i < this.Controller.TQ.currentResult.stopL.length; i++) {
        if (this.Controller.TQ.currentResult.stopL[i].idx == data.locIndex) {
          var loc = this.Controller.TQ.currentResult.stopL[i].locResolved;
        }
      }
      if (typeof loc == "undefined")
        return;
      var locKey = Hafas.Modules.Render.objectKeeper.keep(loc);
      var map = this.Controller.Map.instance;
      var selectLocationAction;
      if (Hafas.Util.getLayoutClass() === 'small') {
        selectLocationAction = Hafas.Config.TQ.selectLocationActionMobile;
      } else {
        selectLocationAction = Hafas.Config.TQ.selectLocationActionDesktop;
      }
      // Check if SQ is available, otherwise use MoveMap as a fallback
      if (this.Controller.SQ === undefined || this.Controller.SQ.instance === undefined){
        selectLocationAction = 'MoveMap';
      }
      if (selectLocationAction === "SwitchToSQInfo" && Hafas.Config.SQ && Hafas.Config.SQ.useInfo !== true) {
        // Fallback to SQ board if it should be SQ info, but SQ info is not available
        selectLocationAction = "SwitchToSQBoard";
      }
      switch (selectLocationAction) {
        case "MoveMap":
          // Zoomlevel ggfs. wenn wirklich nötig als Config Parameter, ansonsten erst einmal so gewählt, dass
          // der Halt beim Centern nah genug dran ist
          Hafas.ps.pub('/map/centerToGeo/webapp', [{coord: Hafas.Util.geo.hciCrdToHafasCoord(loc.crd), zoom: 14}]);
          Hafas.Util.location.getLocDetails(loc, function (locDetailsResult) {
            var result = locDetailsResult.svcResL[0].res;
            Hafas.ps.pub('/map/clickOnLocation', [map, result.locL[0], result.common, {}, {lazyLoadLines: false}]);
          });
          break;
        case "SwitchToSQInfo":
          Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "info"]);
          Hafas.bind(this.Controller.TQ.hideResult, this)();
          break;
        case "SwitchToSQBoard":
          Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "dep"]);
          break;
      }
    }
  },

  /**
   * @method hideAllTrainRoutes();
   * @public
   */
  hideAllTrainRoutes: function (data) {
    var _coll = Hafas('.lyr_SQOverviewResults .hfs_itemResults .hfs_tqInnerResultWrap', true);
    _coll.forEach(function (itm, idx) {
      if (itm.className.match(/js_tqResultOpened/g)) {
        itm.style.display = "none";
        itm.removeClassName('js_tqResultOpened');
      }
    });
  },

  /**
   * @method showTrainroute();
   * @public
   */
  showTrainroute: function (opts) {
    var me = this;
    var data = opts.data;

    if (Hafas.Modules.History) {
      Hafas.Modules.History.addData("TQ", "result", opts);
    }

    // show loader to prevent doubleclicks on label
    if (opts.data.trigger) {
      var $trigger = opts.data.trigger,
      _triggerHeight = $trigger.offsetHeight,
      _triggerInner = $trigger.innerHTML;

      if ($trigger.nodeName) {
        $trigger.style.height = _triggerHeight + 'px';
        $trigger.innerHTML = '<div class="hfs_spinner"></div>';
      }
    }

    var params = {
      jid: data.jid,
      callback: function (model) {
        model.startIdx = 0;
        model.endIdx = model.stopL.length;
        if (data.extId) {
          model.extId = data.extId;
        }
        if ($trigger && $trigger.nodeName) {
          model.trigger = $trigger;
          model.triggerInner = _triggerInner;
        }
        model.openedFromContext = opts.data.openedFromContext;

        model.viewHeader = {
          title: Hafas.Modules.i18n.get('TQ.index.t_N_applicationName')
        };

        if (typeof opts.data.independent != 'undefined') {
          model.independent = opts.data.independent;
        } else {
          model.independent = false;
        }

        Hafas.ps.pub('/app/switchContext', [{context: "TQ"}]);
        Hafas.bind(me.Controller.TQ.renderResultView, me)(model);

        //announce header text
        var actionbarTitle = Hafas(".lyr_atomActionbarTitle", false, Hafas("#TQ_Result"));
        if (actionbarTitle !== null) {
          Hafas.Modules.a11y.Announce.assertive(actionbarTitle.innerText);
        }
        // focus first Element (Backbutton)
        Hafas.Util.gui.focusFirstElement("#TQ_Result");

        // Tracking
        Hafas.ps.pub('/tracking/screen/journey-details', [{typ: 'screen', key: 'journey-details'}]);
        Hafas.ps.pub('/tracking/screen/route-details', [{typ: 'screen', key: 'route-details'}]);

        // Ergebnisse weiterleiten, werden von Timetable gebraucht /mroe
        Hafas.ps.pub('/trainroute/results', [model]);
      }
    };

    if (typeof data.fIdX != "undefined") {
      params.fIdX = data.fIdX;
    }
    if (typeof data.tIdX != "undefined") {
      params.tIdX = data.tIdX;
    }

    if (typeof data.date != 'undefined') {
      params.date = data.date;
    }

    if (typeof me.Controller.Map != 'undefined' && typeof me.Controller.Map.instance != 'undefined') {
      params.map = me.Controller.Map.instance;
    }

    if (typeof me.Controller.TQ.currentTrainroute != 'undefined' && me.Controller.TQ.currentTrainroute != null) {
      me.Controller.TQ.currentTrainroute.hide();
    }
    me.Controller.TQ.currentTrainroute = Hafas.Core.newType("hafasTrainroute", params);
  },
  /**
   * Redraw the current train route, e.g. when changing the color scheme.
   */
  redrawTrainroute: function () {
    if (this.Controller.TQ.currentTrainroute) {
      Hafas.bind(this.Controller.TQ.refreshTrainRoute, this)();
    }
  },
  centerTrainroute: function () {
    var me = this;
    window.setTimeout(function () {
      if (me.appContext === 'TQ') {
        try {
          me.Controller.TQ.currentTrainroute.map.centerToContent(me.Controller.TQ.currentTrainroute.mapContent.centerPoly);
        } catch (e) {
          Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "tq.centerTrainroute", "Karte konnte nicht auf Connection zentriert werden.", e);
        }
      }
    }, 500);
  },
  renderResultView: function (model) {
    var me = this;
    this.Controller.TQ.currentResult = model;

    Hafas.Modules.Render.render(
    {
      file: 'tq.result.html',
      target: 'TQ_Result',
      template: 'TQ_AtomTplResult',
      model: model
    },
    function () {
      // show the additional container
      if (typeof model.trigger != 'undefined') {
        if (model.trigger) {
          model.trigger.innerHTML = model.triggerInner;
        }
      }

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);

      // verkehrstagekalender?
      if (Hafas.Config.TQ.serviceDays.show && Hafas.Config.TQ.serviceDays.showAsCalendar && (typeof model.sDaysL !== 'undefined')) {
        model.sDaysL.forEach(function (sDays, idx) {
          // bitfolge vorhanden?
          if (typeof sDays.sDaysB !== 'undefined') {
            var sDTPConfig = {
              holder: 'HFS_ServiceDaysCalendar_TQ' + idx + '_Calendar',
              id: 'TQServiceDays_' + idx,
              config: {
                useDepArrSwitch: false,
                useTimePicker: false,
                useNowMode: false,
                isModal: false,
                showFullscreenInMobile: false,
                readOnly: true,
                a11yHidden: true,
                markedDays: sDays.sDaysB
              }
            };

            Hafas.Core.newType('hafasTimeDatePicker', sDTPConfig);
          }

          });
        }
        Hafas.ps.pub('/app/updateBanner', ['tq']);
        // Todo: Trainroute auf der Karte anzeigen
        Hafas.ps.pub('/app/events/resize', [{keepOverviewScrollPos: true, keepDetailsScrollPos: true}]);
        Hafas.ps.pub('/app/events/resize', [{
          container: me.additionalContainer,
          appcontext: me.appContext,
          keepOverviewScrollPos: true,
          keepDetailsScrollPos: true,
          method: '/tq/showTrainroute'
        }]);
        // Nach ganz oben scrollen, wenn Zuglauf geöffnet wird
        Hafas.Util.gui.resetScrollTop();

        if (me.Controller.TQ.focusSelector) {
          Hafas.Util.gui.restoreFocus(me.Controller.TQ.focusSelector);
          me.Controller.TQ.focusSelector = null; // avoid unintentionally restoring focus later on
        }
      }
    );
  },
  closeView: function (histData) {
    switch (histData.view) {
      case "result":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView: function (histData) {
    var view = histData.view;
    switch (view) {
      case "result":
        Hafas.bind(this.Controller.TQ.showTrainroute, this)(histData.data);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderJourneyDetails'}]);
        break;
    }
    // PageContent muss wieder eingeblendet werden, da er zuvor im GUI Controller ausgeblendet wird
    if (this.layoutClass == "small") {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
    }

  },
  refresh: function (param) {
    this.Controller.TQ.focusSelector = Hafas.Util.gui.getFocusElementSelector(); // save refresh button selector to restore focus to

    if (param.ev) {
      param.ev.preventDefault();
      param.ev.stopPropagation();
    }
    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get("a11y.announce.t_N_areUpdating", {elem: Hafas.Modules.i18n.get("TQ.index.t_N_JourneyDetails")}));
    // Add Loader
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite");
    Hafas('#TQ_Result [data-render-element="result_header"]').insertAdjacentHTML('afterbegin', loaderHtml);
    var refreshBtn = Hafas('#HFS_TQRefreshBtn');
    if (refreshBtn) refreshBtn.disabled = true;
    Hafas.bind(this.Controller.TQ.refreshTrainRoute, this)();

  },
  refreshTrainRoute: function () {
    var me = this;
    var currentTrainroute = this.Controller.TQ.currentTrainroute;
    var params = {
      jid: this.Controller.TQ.currentTrainroute.jid,
      map: this.Controller.Map.instance,
      callback: function (model) {
        Hafas.bind(me.Controller.TQ.renderResultView, me)(model);
      },
      onbeforedraw: function(trainRouteInstance){
        // Beim Refreshen muss darauf geachtet werden, dass die vorherige Route sauber abgeräumt wird
        if(currentTrainroute){
          currentTrainroute.hide();
        }
      }.bind(this)
    };
    this.Controller.TQ.currentTrainroute = Hafas.Core.newType("hafasTrainroute", params);

  },
  cleanup: function () {
    Hafas.bind(this.Controller.TQ.hideResult, this)();
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/livemap/clearJourneyFilter', [true, true]);
  }
};
